import React, { Component } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/th';

dayjs.locale('th');

export class ContactMessages extends Component {
    constructor(props) {
        super(props);
        this.state = { list: [], loading: true, search: '', statusFilter: '', selected: null };
    }

    componentDidMount() { this.load(); }

    load() {
        this.setState({ loading: true });
        var q = this.state.statusFilter ? '?status=' + this.state.statusFilter : '';
        fetch('api/contact' + q)
            .then(r => r.ok ? r.json() : [])
            .then(list => this.setState({ list, loading: false }))
            .catch(() => this.setState({ loading: false }));
    }

    async markRead(m, read) {
        try {
            await fetch('api/contact/' + m.id + '/read?read=' + read, { method: 'POST' });
            this.load();
        } catch {}
    }

    async del(m) {
        if (!window.confirm('ต้องการลบข้อความนี้?')) return;
        try {
            await fetch('api/contact/' + m.id, { method: 'DELETE' });
            this.setState({ selected: null });
            this.load();
        } catch {}
    }

    openDetail(m) {
        this.setState({ selected: m });
        if (m.isRead === 0) this.markRead(m, 1);
    }

    getFiltered() {
        var { list, search } = this.state;
        if (!search.trim()) return list;
        var s = search.trim().toLowerCase();
        return list.filter(m =>
            (m.name || '').toLowerCase().includes(s) ||
            (m.phone || '').toLowerCase().includes(s) ||
            (m.email || '').toLowerCase().includes(s) ||
            (m.message || '').toLowerCase().includes(s));
    }

    render() {
        var { loading, search, statusFilter, selected, list } = this.state;
        var filtered = this.getFiltered();
        var unread = list.filter(m => m.isRead === 0).length;

        return (
            <div style={{ padding: 20 }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <p style={{ margin: 0, fontSize: 13, color: '#888' }}>
                        ทั้งหมด {filtered.length} ข้อความ {unread > 0 && <span style={{ background: '#dc3545', color: '#fff', padding: '2px 10px', borderRadius: 12, fontSize: 11, fontWeight: 700, marginLeft: 6 }}>{unread} ยังไม่อ่าน</span>}
                    </p>
                    <button className="btn btn-outline-secondary btn-sm" onClick={() => this.load()}><i className="fas fa-sync"></i> รีเฟรช</button>
                </div>

                <div style={{ background: '#fff', borderRadius: 10, padding: 14, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', marginBottom: 16 }}>
                    <div className="d-flex flex-wrap" style={{ gap: 8 }}>
                        <button className={'btn btn-sm ' + (statusFilter === '' ? 'btn-dark' : 'btn-outline-secondary')} onClick={() => this.setState({ statusFilter: '' }, () => this.load())}>ทั้งหมด</button>
                        <button className={'btn btn-sm ' + (statusFilter === 'unread' ? 'btn-dark' : 'btn-outline-secondary')} onClick={() => this.setState({ statusFilter: 'unread' }, () => this.load())}><i className="fas fa-envelope" style={{ color: '#dc3545' }}></i> ยังไม่อ่าน</button>
                        <button className={'btn btn-sm ' + (statusFilter === 'read' ? 'btn-dark' : 'btn-outline-secondary')} onClick={() => this.setState({ statusFilter: 'read' }, () => this.load())}><i className="fas fa-envelope-open"></i> อ่านแล้ว</button>
                        <div className="input-group" style={{ maxWidth: 320, marginLeft: 'auto' }}>
                            <span className="input-group-text" style={{ background: '#fff' }}><i className="fas fa-search" style={{ color: '#aaa' }}></i></span>
                            <input className="form-control" placeholder="ค้นหา ชื่อ/เบอร์/เนื้อหา" value={search} onChange={e => this.setState({ search: e.target.value })} style={{ borderLeft: 'none' }} />
                        </div>
                    </div>
                </div>

                {loading ? (
                    <div className="text-center py-5"><div className="spinner-border text-danger"></div></div>
                ) : filtered.length === 0 ? (
                    <div className="text-center py-5" style={{ color: '#bbb' }}>
                        <i className="fas fa-inbox" style={{ fontSize: 48, display: 'block', marginBottom: 12 }}></i>
                        ยังไม่มีข้อความ
                    </div>
                ) : (
                    <div style={{ background: '#fff', borderRadius: 10, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', overflow: 'hidden' }}>
                        <table className="table table-hover" style={{ margin: 0 }}>
                            <thead style={{ background: '#f8f9fa' }}>
                                <tr>
                                    <th style={{ width: 40 }}></th>
                                    <th style={{ width: 160 }}>เวลา</th>
                                    <th>ชื่อ / ติดต่อ</th>
                                    <th>ข้อความ</th>
                                    <th style={{ width: 140, textAlign: 'right' }}>จัดการ</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.map(m => (
                                    <tr key={m.id} style={{ cursor: 'pointer', fontWeight: m.isRead === 0 ? 700 : 400 }} onClick={() => this.openDetail(m)}>
                                        <td><i className={m.isRead === 0 ? 'fas fa-envelope' : 'fas fa-envelope-open'} style={{ color: m.isRead === 0 ? '#dc3545' : '#bbb' }}></i></td>
                                        <td style={{ fontSize: 12, color: '#555', whiteSpace: 'nowrap' }}>{m.timestamp ? dayjs(m.timestamp).format('DD MMM YYYY HH:mm') : '-'}</td>
                                        <td>
                                            <div style={{ fontSize: 13 }}>{m.name || '-'}</div>
                                            <div style={{ fontSize: 11, color: '#888' }}>{m.phone} {m.phone && m.email && '·'} {m.email}</div>
                                        </td>
                                        <td style={{ fontSize: 13, color: '#555', maxWidth: 400, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{(m.message || '').replace(/\n/g, ' ')}</td>
                                        <td style={{ textAlign: 'right' }} onClick={e => e.stopPropagation()}>
                                            <div className="d-inline-flex" style={{ gap: 8 }}>
                                                <button className="btn btn-sm btn-outline-secondary" onClick={() => this.markRead(m, m.isRead === 1 ? 0 : 1)} title={m.isRead === 1 ? 'ทำเครื่องหมายยังไม่อ่าน' : 'ทำเครื่องหมายอ่านแล้ว'}>
                                                    <i className={m.isRead === 1 ? 'fas fa-envelope' : 'fas fa-envelope-open'}></i>
                                                </button>
                                                <button className="btn btn-sm btn-outline-danger" onClick={() => this.del(m)}><i className="fas fa-trash"></i></button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {selected && (
                    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={() => this.setState({ selected: null })}>
                        <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: '90%', maxWidth: 600, maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
                            <div className="d-flex justify-content-between align-items-start mb-3">
                                <div>
                                    <h5 style={{ margin: 0 }}><i className="fas fa-envelope-open-text" style={{ color: '#dc3545' }}></i> ข้อความ #{selected.id}</h5>
                                    <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>{selected.timestamp ? dayjs(selected.timestamp).format('DD MMMM YYYY HH:mm น.') : '-'}</div>
                                </div>
                                <button className="btn btn-sm btn-outline-secondary" onClick={() => this.setState({ selected: null })}>×</button>
                            </div>

                            <div style={{ background: '#f8f9fa', borderRadius: 8, padding: 14, marginBottom: 14 }}>
                                <div className="row g-2" style={{ fontSize: 14 }}>
                                    <div className="col-12"><strong><i className="fas fa-user"></i> ชื่อ:</strong> {selected.name || '-'}</div>
                                    <div className="col-md-6"><strong><i className="fas fa-phone"></i> โทร:</strong> {selected.phone ? <a href={'tel:' + selected.phone}>{selected.phone}</a> : '-'}</div>
                                    <div className="col-md-6"><strong><i className="fas fa-envelope"></i> อีเมล:</strong> {selected.email ? <a href={'mailto:' + selected.email}>{selected.email}</a> : '-'}</div>
                                </div>
                            </div>

                            <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 8, padding: 16, whiteSpace: 'pre-wrap', fontSize: 14, lineHeight: 1.6, color: '#333' }}>
                                {selected.message}
                            </div>

                            <div className="d-flex justify-content-end mt-3" style={{ gap: 8 }}>
                                <button className="btn btn-outline-danger" onClick={() => this.del(selected)}><i className="fas fa-trash"></i> ลบ</button>
                                {selected.phone && <a href={'tel:' + selected.phone} className="btn btn-outline-success"><i className="fas fa-phone"></i> โทรกลับ</a>}
                                {selected.email && <a href={'mailto:' + selected.email} className="btn btn-outline-primary"><i className="fas fa-reply"></i> ตอบกลับทางอีเมล</a>}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
